// extracted by css-extract-rspack-plugin
export default {"Octicon":"ImmutableActionsHasUnmigratableTagsDialog-module__Octicon__qVNUA"};